import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import AvatarName from '@/components/ui/custom/dataDisplay/AvatarName';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { LoadingIcon } from '@/components/icons';
import {
  scheduledLessonsQueryKeys,
  studentAssessmentsQuerykeys,
  usersQueryKeys,
} from '@/data/services/querykeys';
import { OcurrenceAlert } from '@/models/Alert';
import { ROUTES } from '@/utils/routes';
import { useQuery } from '@tanstack/react-query';
import { DetailTargetProps } from '../../card/NotificationTypes';
import DelayNotificationDetail from './DelayNoficationDetail';

const OcurrenceNotificationDetail: React.FC<
  DetailTargetProps<OcurrenceAlert['extraInfo']>
> = ({ target: extraInfo }) => {
  const { data: assessment, isInitialLoading: isAssessmentLoading } = useQuery({
    ...studentAssessmentsQuerykeys.get(extraInfo?.assessmentId ?? 0),
    enabled: !!extraInfo?.assessmentId,
  });

  const { data: author, isInitialLoading: isAuthorLoading } = useQuery({
    ...usersQueryKeys.get(extraInfo?.authorId ?? 0),
    enabled: !!extraInfo?.authorId,
  });

  const { data: scheduledLesson, isInitialLoading: isScheduledLessonLoading } =
    useQuery({
      ...scheduledLessonsQueryKeys.get(
        assessment?.occurrenceAssessment.scheduledLessonId || 0,
      ),
      enabled: !!assessment?.occurrenceAssessment.scheduledLessonId,
    });

  const isLoading =
    isAssessmentLoading || isScheduledLessonLoading || isAuthorLoading;

  if (isLoading) {
    return (
      <div className="w-full flex justify-center">
        <LoadingIcon className="h-5 w-5 text-primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <ConditionalRenderer condition={scheduledLesson}>
        <DelayNotificationDetail
          target={scheduledLesson?.id}
          isLoading={isLoading}
        />
      </ConditionalRenderer>
      <ConditionalRenderer condition={author}>
        <div className="flex items-center flex-wrap relative gap-1">
          {author && (
            <AvatarName
              user={author}
              className="gap-1"
              href={ROUTES.PROFILE.INFO(author.username)}
            />
          )}
          <span className="relative text-base-content right-0.5">:</span>
          <Text
            text={`"${extraInfo?.description}"`}
            className="relative pr-2"
          />
        </div>
      </ConditionalRenderer>
    </div>
  );
};

export default OcurrenceNotificationDetail;
